export default __webpack_public_path__ + "static/logo-hitachi-solutions-23edc1b1d90ec24adeb2dda769398c86.png";